import React, { Component, Fragment } from "react";
//import { connect } from "react-redux";
//import { Link } from "react-router-dom";
/*import { updateCart, removeFromCart } from "../actions/cartActions";*/
import { utils } from "../common/utils";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "./ExtendedLink";
import ArticleNumber from "./ArticleNumber";
import Image from "./Image";
import CurrencyFormat from './CurrencyFormat';

class WebCartLine extends Component {
 

    render() {
        const { t, line, isReadOnly, settings } = this.props;
      const { product } = line;
      const productLink = `/products/${product.id}`;
      const groupsLink = `/categories/${product.groupId}`;
      let quantityControl = line.quantity;
      if (!isReadOnly) {
          // allow edit quantity
          const quantityOptions = [...Array(10)].map((x, i) => (
              <option key={i + 1} value={i + 1}>
                  {i + 1}
              </option>
          ));
          quantityControl = (
              <div className="count-input">
                  <select
                      className="form-control"
                      value={line.quantity}
                      onChange={this.props.onQuantityChange}
                  >
                      {quantityOptions}
                  </select>
              </div>
          );
      }

      const actionColumn = isReadOnly ? <Fragment /> : (
          <td className="text-center">
              <button
                  onClick={this.props.onRemoveLine}
                  className="remove-from-cart btn btn-link"
                  data-toggle="tooltip"
                  title={t("Remove item")}
              >
                  <i className="icon-cross" />
              </button>
          </td>
      );
      return (<tr>
          <td>
              <div className="product-item">
                  <ExtendedLink to={productLink} className="product-thumb">
                      <Image src={product.thumbnail ? product.thumbnail : "img/no-image.jpg"}
                          fallbackSrc="img/no-image.jpg" alt={product.title} />
                  </ExtendedLink>
                  <div className="product-info">
                      <h4 className="product-title">
                          <ExtendedLink to={productLink}>{product.title}</ExtendedLink>
                      </h4>
                      <ArticleNumber stockItemCode={product.stockItemCode} />
                      {/*{product.groupName && <div className="padding-bottom-1x d-block">*/}
                      {/*    <span className="text-medium d-inline-block">{t("Group")}:&nbsp;</span>*/}
                      {/*    <ExtendedLink to={groupsLink} className="navi-link">*/}
                      {/*        {product.groupName}*/}
                      {/*    </ExtendedLink>*/}
                      {/*</div>}*/}
                  </div>
              </div>
          </td>
          <td className="text-center text-lg text-medium">{quantityControl}</td>
          <td className="text-center text-lg text-medium">
              <del>{product.specialPrice < product.originalPrice ? <CurrencyFormat value={product.originalPrice} settings={settings} />: ""}</del> &nbsp;
              <CurrencyFormat value={product.specialPrice} settings={settings} />
          </td>

          <td className="text-center text-lg text-medium">
              <CurrencyFormat value={this.props.totalQuantityPrice} settings={settings} />
             {/* {utils.formatCurrency(this.props.totalQuantityPrice)}*/}
          </td>
          {actionColumn}
      </tr>);

  }
}

export default withTranslation()(WebCartLine);

